import useLayout from "@/hooks/useLayout";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "../inputs/button";
import ButtonGroup from "../buttons/buttonGroup";
import Section from "../layout/section";
import Callout from "../callout/callout";
import ProcessingButton from "../inputs/processingButton";
import { ReactComponent as CheckIcon } from 'assets/icons/check.svg';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import useAccess from "@/hooks/useAccess";
import { decodeFirebaseError } from "utils/firebaseHelpers";

interface RespondAccessInvitationFormProps {
    storageId: string;
    accessId: string;
    accept: boolean;
}

const RespondAccessInvitationForm: React.FC<RespondAccessInvitationFormProps> = ({ storageId, accessId, accept }) => {

    const { t } = useTranslation()

    const [errors, setErrors] = useState<string[]>([]);

    const {
        respondToInvitation,
        isResponding
    } = useAccess({});

    const {
        closeDialog,
        addToast
    } = useLayout()

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        setErrors([])

        try {
            await respondToInvitation({ storageId, accessId, accept })
            closeDialog()
            addToast({
                text: t(accept ? 'toastAccessInvitationAccepted' : 'toastAccessInvitationDeclined'),
                colorScheme: accept ? 'green' : 'yellow'
            })
        } catch (e: unknown) {
            const errorMessage = decodeFirebaseError(e instanceof Error ? e.message : String(e))
            setErrors([errorMessage])
        }
    }

    return (
        <form onSubmit={handleSubmit}>
            <Section>
                <p>{t(accept ? 'acceptAccessConfirmation' : 'declineAccessConfirmation')}</p>
                {errors.length > 0 && <Callout type="error">{errors.join(', ')}</Callout>}
                <ButtonGroup>
                    {isResponding ? (
                        <ProcessingButton design="primary" />
                    ) : (
                        <>
                            <Button wideOnMobile type="button" onClick={closeDialog} design="optional"><CloseIcon /><span>{t('buttonCancel')}</span></Button>
                            <Button wideOnMobile type="submit" design={accept ? 'primary' : 'danger'}>
                                {accept ? <CheckIcon /> : <CloseIcon />}
                                <span>{t(accept ? 'buttonAccept' : 'buttonDecline')}</span>
                            </Button>
                        </>
                    )}
                </ButtonGroup>
            </Section>
        </form>
    )
}

export default RespondAccessInvitationForm
